// extracted by mini-css-extract-plugin
export var linkText = "_pz-0";